/**
 * Proposal status constants.
 *
 * Complete `proposal_status` value set (contact_proposals.status; mirrored by
 * codegen `Proposal_Status`). Use `z.enum(PROPOSAL_STATUS_VALUES)` — never a
 * hand-typed literal (a schema that omitted `viewed` silently rejected it).
 * `satisfies readonly Proposal_Status[]` breaks `tsc` if the DB enum drifts.
 */

import type { Proposal_Status } from "@/src/gql/graphql";

export const PROPOSAL_STATUS_VALUES = [
  "draft",
  "sent",
  "viewed",
  "accepted",
  "rejected",
  "expired",
] as const satisfies readonly Proposal_Status[];
